module.exports = __webpack_public_path__ + "static/media/gc-barco.21596513.png";